import { createRootRoute, Outlet } from "@tanstack/react-router"
import NotFoundPage from "~/components/NotFoundPage"
import { ClientProviders } from "~/layouts/client-providers"

function RootComponent() {
  return (
    <ClientProviders>
      <Outlet />
    </ClientProviders>
  )
}

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: () => <NotFoundPage />,
})
